import React from 'react';

import styles from './styles.scss';
import i18n from '../../../../../i18n';

const ViewTypes = {
  intoYard: i18n.t('constants.view_type.rightMenu.intoYard'),
  toMountains: i18n.t('constants.view_type.rightMenu.toMountains'),
  onSea: i18n.t('constants.view_type.rightMenu.onSea'),
  toPark: i18n.t('constants.view_type.rightMenu.toPark'),
  toGarden: i18n.t('constants.view_type.rightMenu.toGarden'),
  toForest: i18n.t('constants.view_type.rightMenu.toForest'),
  onSocialObjects: i18n.t('constants.view_type.rightMenu.onSocialObjects'),
  panoramicView: i18n.t('constants.view_type.rightMenu.panoramicView')
};

export const ViewType = ({ view_type }) => {
  if (!view_type) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      <span className={styles.Container}>
        {ViewTypes[view_type]}
      </span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Building/Chess/RightMenu/ViewType/index.jsx